const AU = "AU"
const NZ = "NZ"
const US = "US"
const MY = "MY"
const HU = "HU"

exports.countries = [
  { "country": "Australia", "countryCode": AU, "value": "Australia", "label": "Australia (AU)" },
  { "country": "New Zealand", "countryCode": NZ, "value": "New Zealand", "label": "New Zealand (NZ)" },
  { "country": "United States", "countryCode": US, "value": "United States", "label": "United States (US)" },
  { "country": "Malaysia", "countryCode": MY, "value": "Malaysia", "label": "Malaysia (MY)" },
  { "country": "Hungary", "countryCode": HU, "value": "Hungary", "label": "Hungary (HU)" }
]

exports.AU = AU
exports.NZ = NZ
exports.US = US
exports.MY = MY
exports.HU = HU